export default __webpack_public_path__ + "static/media/slitting.653efd09.jpg";